export const tr = {
    'cant-read-unexpected-data': 'Veri yapısı yanlış',
    'required-not-empty-field': 'Bu alanın doldurulması zorunludur. Sütun: {columns}, hücre adresi: {address}',
    'unknown-error-text': 'Hata oluştu. Lütfen, daha sonra tekrar deneyin',
    'wrong-value-format': 'Alan değeri hatalı'
};
